import { render, staticRenderFns } from "./SidebarCrmContactBlock.vue?vue&type=template&id=06a26172&scoped=true"
import script from "./SidebarCrmContactBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarCrmContactBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarCrmContactBlock.vue?vue&type=style&index=0&id=06a26172&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a26172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a26172')) {
      api.createRecord('06a26172', component.options)
    } else {
      api.reload('06a26172', component.options)
    }
    module.hot.accept("./SidebarCrmContactBlock.vue?vue&type=template&id=06a26172&scoped=true", function () {
      api.rerender('06a26172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarCrmContactBlock.vue"
export default component.exports